var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    transform: "rotate(0,128,128) translate(21,37.3616749581519) scale(6.70846362895601,6.70846362895601)",
    fill: "#2dd5ff",
    d: "M15.820005,2.5450472L4.8299956,11.276844 4.8299956,25.022081 10.818996,25.022081 10.818996,18.522081C10.818996,16.04108 13.059997,14.02208 15.813997,14.02208 18.567999,14.02208 20.807999,16.04108 20.807999,18.522081L20.807999,25.022081 26.796999,25.022081 26.796999,11.109284z M15.808004,0L31.900002,12.55507 30.670006,14.131 28.796999,12.669682 28.796999,27.022081 18.807999,27.022081 18.807999,18.522081C18.807999,17.14308 17.464998,16.022081 15.813997,16.022081 14.161997,16.022081 12.818997,17.14308 12.818997,18.522081L12.818997,27.022081 2.8299954,27.022081 2.8299954,12.865887 1.2439995,14.125995 0,12.560075z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d4ef8f44a5a72921ba4dc89684516fc0.svg";
export { ForwardRef as ReactComponent };